import { Injectable } from '@angular/core';

@Injectable()
export class LzProductConfig {

  private productConfig = {
    'ipas_location': '',
    'ips_location': '',
    'order_code': '',
    'product_name': '',
    'product_version': '',
    'check_user_session': '',
    'isShowSlidersOnRegAndTestFroms': '',
    'header_profile_buttons': []
  };

  constructor() {

  }

  public getProductSettings = () => {
    return this.productConfig;
  }

  public identifyPlatform = () => {
    try {
      let href = window.location.host;
      if ((href.indexOf('localhost') != -1) || (href.indexOf('-dev') != -1)) {
        return '-dev';
      } else {
        if (href.indexOf('-test') != -1) {
          return '-test';
        } else {
          return '';
        }
      }
    } catch (e) {
      return '';
    }
  }

  public getApiLink = () => {
    return 'https://api' + this.identifyPlatform() + '.ligazakon.net';
  }

  public setProductSettings = (settings) => {
    try {
      for (let key in settings) {
        if (settings.hasOwnProperty(key) && this.productConfig.hasOwnProperty(key)) {
          this.productConfig[key] = settings[key];
        }
      }
    } catch (error) {
      console.log("Error while adding prodcuts settings");
    }
  }

}
